<template>
  <div class="smartz-devices-page chart-content">
    <div ref="print" class="page-card-wrapper">
      <div class="page-card-title">
        <span class="page-card-title-text pointer">{{
          $t('text.smartz_devices')
        }}</span>
      </div>
      <div class="page-card-content">
        <div class="mt-20" v-if="data.length" v-loading="loading">
          <div v-for="(item, index) in data" :key="index" class="device-item">
            <span
              class="status-bar"
              :class="
                item.podStatus === 'RED'
                  ? 'red-bg'
                  : item.podStatus === 'YELLOW'
                  ? 'yellow-bg'
                  : 'green-bg'
              "
            ></span>
            <div class="inline-block mr-30 w-70">
              <div class="black-big-font">
                POD:{{
                  item.podMac.substring(
                    item.podMac.length - 3,
                    item.podMac.length
                  )
                }}
              </div>
              <div class="black-big-font">{{ item.alias }}</div>
            </div>
            <br class="show-mobile" />
            <div class="inline-block mr-20">
              <div class="light-black-big-font">{{ $t('text.last_seen') }}</div>
              <div class="light-black-big-font">{{ $t('text.battery') }}</div>
            </div>
            <div class="inline-block mr-30 w-70">
              <div class="black-big-font">
                {{ item.lastSeen | secondFormat }}({{ $t('text.ago') }})
              </div>
              <div class="black-big-font">{{ item.battery }}%</div>
            </div>
            <br class="show-mobile" />
            <div class="inline-block mr-20">
              <div class="light-black-big-font">{{ $t('text.date_rate') }}</div>
              <div class="light-black-big-font">{{ $t('text.online') }}</div>
            </div>
            <div class="inline-block mr-30 w-70">
              <div class="black-big-font">{{ item.dataRate }} per min</div>
              <div class="black-big-font">{{ item.onlineDays }} days</div>
            </div>
            <br class="show-mobile" />
            <div class="inline-block mr-20">
              <div class="light-black-big-font">{{ $t('text.singnal') }}</div>
              <div class="light-black-big-font">
                {{ $t('text.pad_cycles') }}
              </div>
            </div>
            <div class="inline-block">
              <div class="black-big-font">{{ item.signalStatus }}</div>
              <div class="black-big-font">{{ item.padCycles }}</div>
            </div>
          </div>
        </div>
        <div
          v-else
          v-loading="loading"
          class="device-item no-data min-h-300 mt-20 v-h-center secondary-font"
        >
          {{ $t('text.no_data') }}
        </div>
      </div>
    </div>
    <div class="action-btns mt-20">
      <div
        class="action-btn"
        @click="share()"
        v-if="p('Patients.Charts Module.Smartz Devices Chart.Share')"
      >
        <svg-icon
          iconClass="share"
          class="w-15 mr-10"
          className="white-font"
        ></svg-icon>
        <span>{{ $t('text.share') }}</span>
      </div>
      <div
        class="action-btn"
        @click="print()"
        v-if="p('Patients.Charts Module.Smartz Devices Chart.Print')"
      >
        <svg-icon
          iconClass="report"
          class="w-15 mr-10"
          className="white-font"
        ></svg-icon>
        <span>{{ $t('text.print') }}</span>
      </div>
    </div>
    <ShareDialog ref="shareDialog" />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import ShareDialog from '@/components/patients/charts/ShareDialog'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import $ from 'jquery'
export default {
  data() {
    return {
      data: [],
      loading: false
    }
  },
  components: {
    ShareDialog
  },
  mounted: function() {
    this.getData()
  },
  computed: {
    subject() {
      return this.$t('text.Smartz Devices Chart')
    }
  },
  methods: {
    getData() {
      const date = ''
      this.loading = true
      ApiService.GetDeviceStatus(date)
        .then(response => {
          this.loading = false
          this.data = response.data.map(item => {
            let statusValue
            if (item.podStatus === 'GREEN') {
              statusValue = 3
            } else if (item.podStatus === 'YELLOW') {
              statusValue = 2
            } else {
              statusValue = 1
            }
            return {
              ...item,
              statusValue: statusValue
            }
          })
          this.data.sort(function(a, b) {
            if (a.statusValue < b.statusValue) {
              return -1
            } else if (a.statusValue == b.statusValue) {
              return 0
            } else {
              return 1
            }
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    share() {
      this.$refs.shareDialog.openDialog('smartz_devices')
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false,
        onclone: doc => {
          $(doc)
            .find('body')
            .css('width', '1000px')
          $(doc)
            .find('.new-design .sidebar-type-page-content')
            .css('width', '100%')
          $(doc)
            .find('.new-design .page-card-wrapper')
            .css('max-width', 'unset')
          $(doc)
            .find('.new-design .page-card-wrapper .page-card-content')
            .css('height', 'auto')
          $(doc)
            .find('.show-mobile')
            .css('display', 'none')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .page-card-title-text'
            )
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .date-wrapper'
            )
            .css('position', 'absolute')
            .css('top', '6px')
            .css('right', '10px')
          $(doc)
            .find('.el-range-editor .el-range-input')
            .css('line-height', '24px')
          $(doc)
            .find('.new-design .smartz-devices-page .device-item')
            .css('max-width', 'unset')
            .css('width', '950px')
        }
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@page {
  size: landscape;
}
</style>
